<template>
  <div class="p-5">
    <div class="border-bottom">
      <div
        class="row mb-5"
        v-for="(tracker, label) in trackers"
        :key="label"
      >
        <label
          :for="label"
          class="col-2 mb-0 py-2"
        >{{ txtToTitle(label) }}:</label>
        <b-form-input
          :id="label"
          :value="tracker ? tracker.value : null"
          @input="updateSelectedItem(selectedItem, $event)"
          class="col-9"
          @blur="validateTracker(selectedItem, tracker.value)"
          @focus="selectTrackerToEdit(label)"
          @keyup.enter="validateTracker(selectedItem, tracker.value)"
        />
        <status-btn
          v-if="tracker.trackerId"
          class="col-1"
          :tracker-type="label"
          :trackers-info="[tracker]"
          :scope="'CONTENT_ITEM'"
          disabled
        />
      </div>
    </div>
    <div class="mt-5">
      <div
        v-for="(thirdPartyTrackers, label, i) in thirdPartyTags"
        :key="i"
        class="mb-4"
      >
        <div v-if="thirdPartyTrackers.length > 0">
          <p class="mb-1">
            {{ txtToTitle(label) }}:
          </p>
          <div
            v-for="({trackerId, value}, indexInArray) in thirdPartyTrackers"
            :key="trackerId"
            class="d-flex flex-nowrap align-items-center"
          >
            <b-form-input
              readonly
              :value="value"
            />
            <i
              @click="deleteThirdPartyTracker(label, indexInArray, trackerId)"
              class="fas fa-trash-alt trash-alt ml-5"
            />
          </div>
        </div>
      </div>
      <p>ADD A NEW 3RD PARTY TAGS:</p>
      <b-input-group>
        <template #prepend>
          <b-form-select
            :options="options"
            v-model="selectedOption"
          />
        </template>
        <b-form-input v-model="newThirdPartyTag" />
        <template #append>
          <b-button
            @click="addThirdPartyTracker(selectedOption, newThirdPartyTag)"
            variant="primary"
            :disabled="!newThirdPartyTag"
          >
            SUBMIT
          </b-button>
        </template>
      </b-input-group>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import { mapActions, mapState } from 'vuex';
import StatusBtn from '../trackerHealth/StatusBtn.vue';
import * as trackersTypes from '@/modules/trackers/store/types';

export default {
  name: 'EditTrackersPanel',
  components: { StatusBtn },
  props: {
    item: {
      type: Object,
      required: true,
    },
    trackerCombination: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedItem: 'clickTracker',
      originalTrackerValue: '',
      trackers: {},
      thirdPartyTags: {},
      newThirdPartyTag: '',
      options: ['SCRIPT', 'IMAGE'],
      selectedOption: 'SCRIPT',
      group: '',
      contentItemUuid: '',
      index: '',
    };
  },
  mounted() {
    this.getTrackersFromItem(this.item);
    this.group = this.trackerCombination;
    this.contentItemUuid = this.item?.contentItemUuid;
    this.index = this.contentItemUuid ? this.groupedTrackersList[this.group].findIndex((item) => item.contentItemUuid === this.contentItemUuid) : null;
    if (this.item.scope === 'FEED') this.index = 0;
  },
  methods: {
    ...mapActions('trackers', [
      trackersTypes.ADD_TRACKER_TO_GROUPED_LIST_ITEM,
      trackersTypes.UPDATE_ITEM_IN_GROUPED_LIST,
      trackersTypes.DELETE_TRACKER_FROM_GROUPED_LIST_ITEM,
    ]),
    setOriginalItem(value) {
      this.originalTrackerValue = value;
    },
    txtToTitle(text) {
      const title = _.startCase(text).toUpperCase();
      return title.replace('TRACKER', 'TAG');
    },
    getTrackersFromItem(item) {
      for (const [key, value] of Object.entries(item)) {
        // Extract: impressionTracker, clickTracker, postClickTracker as trackers...
        if (key.match(/Tracker$/)) {
          this.trackers = { ...this.trackers, [key]: value || { value: '' } };
        }
        // Extract: imageTrackers, scriptTrackers as thirdPartyTags...
        if (key.match(/Trackers$/)) {
          this.thirdPartyTags = { ...this.thirdPartyTags, [key]: value || { value: '' } };
        }
      }
    },
    selectTrackerToEdit(item) {
      this.setOriginalItem(this.trackers[item].value);
      this.selectedItem = item;
    },
    updateSelectedItem(prop, value) {
      this.trackers[prop].value = value;
    },
    async validateTracker(prop, trackerValue) {
      const isValueChanged = this.originalTrackerValue !== trackerValue;
      if (!isValueChanged) return;

      const trackerId = this.groupedTrackersList[this.group][this.index]?.[prop]?.trackerId;
      if (trackerValue === '') {
        if (!trackerId) return;
        await this.DELETE_TRACKER_FROM_GROUPED_LIST_ITEM({
          groupName: this.group, index: this.index, trackerId, trackerType: prop, trackerValue: null,
        });
        return;
      }
      if (!prop) { throw new Error('no prop provided'); }

      const getGroupIds = (trackerItem) => {
        const {
          creativeId, publisherId, countryIds, geoGroupsIds,
        } = trackerItem;
        return {
          creativeId, publisherId, countryIds, geoGroupsIds,
        };
      };

      const item = {
        ...this.item,
        ...getGroupIds(this.groupedTrackersList[this.group][0]),
      };
      if (!trackerId) {
        return await this.ADD_TRACKER_TO_GROUPED_LIST_ITEM({
          groupName: this.group, index: null, item, trackerType: prop, trackerValue,
        });
      }
      return await this.UPDATE_ITEM_IN_GROUPED_LIST({
        groupName: this.group, index: this.index, trackerId, item, trackerType: prop, trackerValue,
      });
    },
    async addThirdPartyTracker(type, value) {
      const trackerType = `${_.lowerCase(type)}Trackers`;
      const result = await this.validateTracker(trackerType, [value]);
      if (result) this.thirdPartyTags[trackerType].push(result.trackers[0]);
    },
    async deleteThirdPartyTracker(type, index, trackerId) {
      this.thirdPartyTags[type].splice(index, 1);
      await this.DELETE_TRACKER_FROM_GROUPED_LIST_ITEM({
        groupName: this.group, index: this.index, trackerId, trackerType: type, trackerValue: this.thirdPartyTags[type],
      });
    },
  },
  computed: {
    ...mapState('content', ['contentItems']),
    ...mapState('trackers', ['groupedTrackersList']),
  },
};
</script>
